import React from 'react'
import { Link } from 'react-router-dom'

const CardHomeAgenda = (props) => {
    return (
        <div className="card m-4 shadow ">
          <Link to="/agenda">
            <div  className="card-img-top"  style={{backgroundImage: `url(${props.imgbg})`, height: 350+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} />
          </Link>
		</div>
    )
}

export default CardHomeAgenda
